import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { SEARCH_MIN_CHARS, type SearchResponse } from '@nexops/shared';
import { api } from '@/shared/lib/api';

export const searchKeys = { all: ['global-search'] as const };

/** Server-side search (scoped + permission-gated by the backend). Disabled below the minimum query length. */
export function useGlobalSearch(query: string) {
  const q = query.trim();
  return useQuery({
    queryKey: [...searchKeys.all, q],
    queryFn: ({ signal }) => api.get<SearchResponse>('/search', { q, limit: 5 }, { signal }),
    enabled: q.length >= SEARCH_MIN_CHARS,
    placeholderData: keepPreviousData,
    staleTime: 15_000,
    retry: false,
    meta: { silent: true },
  });
}
